/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/** A Date as the local `YYYY-MM-DD` the kit DateRangePicker speaks. */
export function localIsoDate(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/** The last `days` calendar days, today included, as inclusive `YYYY-MM-DD` picker bounds. */
export function lastDays(days: number, now: Date = new Date()): { from: string; to: string } {
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - (days - 1));
  return { from: localIsoDate(start), to: localIsoDate(now) };
}

/**
 * Local midnight at the start of a `YYYY-MM-DD` day, `offsetDays` calendar days later, in epoch
 * milliseconds. Moving by calendar day (not by 24 hours) keeps the bound on midnight across a
 * daylight-saving change.
 */
export function startOfLocalDay(iso: string, offsetDays = 0): number {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d + offsetDays).getTime();
}
